import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import menu from './modules/menu'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    menu,
    user
  },
  getters: {
    menuList: (state) => state.menu.menuList,
    menuListCode: (state) => state.menu.menuListCode,
    currentTab: (state) => state.menu.currentTab,
    tabs: (state) => state.menu.tabs,
    token: (state) => state.user.token,
    userInfo: (state) => state.user.userInfo,
    orgList: (state) => state.menu.orgList,
    roleList: (state) => state.menu.roleList,
    customerInfo: (state) => state.menu.customerInfo,
    userName: (state) => state.menu.userName
  },
  plugins: [createPersistedState()],
  state: {
    updateAlarm: 0
  },
  mutations: {
    setUpdateAlarm(state, newUpdateAlarm) {
      state.updateAlarm = newUpdateAlarm;
    }
  }
})
